import i18n from '@dinosband/bv-i18n'
import { ChatRoomProcess, ProcessAction, ProcessState } from '@dinosband/bv-main-schema/dist/types'
import { MessageTransaction } from '@dinosband/bv-messenger-schema'

export const defaultProcessDictionary: Record<string, Record<string, string>> = {
  'ko': {
    // common
    'cm:hire': '고용',
    // state
    'st:Start': '모집 중',
    'st:Open': '협의 중',
    'st:Hired': '업무 진행 중',
    'st:WorkFinished': '리뷰 중',
    'st:Closed': '완료됨',
    'st:Canceled': '취소 요청 중',
    // act
    'act:Apply': '지원하기',
    'act:Ask-hire': '고용 요청하기',
    'act:Hire': '고용하기',
    'act:Ask-finish': '업무 종료 요청하기',
    'act:Finish': '업무 종료하기',
    'act:Cancel': '고용 취소 요청하기',
    'act:Agree-Cancel': '고용 취소 합의하기',
    'act:Cancel-Cancel': '고용 취소 요청 철회하기',
    'act:Ask-Refund': '환불 금액 제안 요청하기',
    'act:Propose-Refund': '환불 금액 제안하기',
    'act:Edit-Refund': '환불 금액 변경하기',
    'act:Set-Price': '가격 입력하기',
    'act:Review': '리뷰하기',
    'act:Close-Offer': '공고 마감하기',
    'act:Change-JobReward': '보상 변경하기',
    'act:Verify-Account': '인증하기',
    // ask
    'ask:Apply': '지원하시겠습니까?',
    'ask:Ask-hire': '고용을 요청하시겠습니까?',
    'ask:Hire': '고용하시겠습니까?',
    'ask:Ask-finish': '업무 종료 확인을 요청하시겠습니까?',
    'ask:Finish': '업무가 종료된 것으로 승인하시겠습니까?',
    'ask:Cancel': '고용 취소 요청을 보내시겠습니까?',
    'ask:Agree-Cancel': '고용 취소를 합의하시겠습니까?',
    'ask:Cancel-Cancel': '고용 취소 요청을 철회하시겠습니까?',
    // tr
    'tr:Apply': '{profile}님이 지원하셨습니다.',
    'tr:Ask-hire': '{profile}님이 고용을 요청하셨습니다.',
    'tr-ask:Ask-hire': '고용을 원하시면 화면 윗부분의 "고용하기" 버튼을 눌러주시기 바랍니다.',
    'tr:Hire': '{profile}님이 {partner}님을 고용하셨습니다.',
    'tr:Ask-finish': '{profile}님이 업무 종료를 요청하셨습니다.',
    'tr-ask:Ask-finish': '업무가 잘 마무리 되었다고 생각하시면 화면 윗부분의 "업무 종료하기" 버튼을 눌러주시기 바랍니다.',
    'tr:Finish': '{profile}님이 업무를 종료하셨습니다.',
    'tr:Cancel': '{profile}님이 고용 취소를 요청하셨습니다.',
    'tr-ask:Cancel': '취소에 합의하시면 "고용 취소 합의하기"를 눌러주시고, 그렇지 않으시면 반대 의사를 메시지로 보내주시기 바랍니다.',
    'tr:Agree-Cancel': '{profile}님이 고용 취소를 합의하셨습니다.',
    'tr:Cancel-Cancel': '{profile}님이 고용 취소 요청을 철회하셨습니다.',
    'tr:Set-Price': '{profile}님이 가격을 {price}으로 정하셨습니다.',
    'tr:Review': '{profile}님이 {partner}님에 대한 리뷰를 올리셨습니다.',
  },
  'en': {
    // common
    'cm:hire': 'hire',
    // state
    'st:Start': 'Recruiting',
    'st:Open': 'Discussing',
    'st:Hired': 'Work in Progress',
    'st:WorkFinished': 'Reviewing',
    'st:Closed': 'Completed',
    'st:Canceled': 'Requested to Cancel',
    // act
    'act:Apply': 'Apply',
    'act:Ask-hire': 'Ask to Hire',
    'act:Hire': 'Hire',
    'act:Ask-finish': 'Ask to Declare Contract Fulfilled',
    'act:Finish': 'Declare Contract Fulfilled',
    'act:Cancel': 'Ask to Cancel Contract',
    'act:Agree-Cancel': 'Agree to Cancel Contract',
    'act:Cancel-Cancel': 'Withdraw Cancellation Request',
    'act:Ask-Refund': 'Ask to Propose Refund Amount',
    'act:Propose-Refund': 'Propose Refund Amount',
    'act:Edit-Refund': 'Modify Refund Amount',
    'act:Set-Price': 'Enter Price',
    'act:Review': 'Review',
    'act:Close-Offer': 'Close Offer',
    'act:Change-JobReward': 'Change Job Reward',
    'act:Verify-Account': 'Authenticate',
    // ask
    'ask:Apply': 'Would you like to apply?',
    'ask:Ask-hire': 'Would you like to ask to hire?',
    'ask:Hire': 'Would you like to hire?',
    'ask:Ask-finish': 'Would you like to ask to declare contract fulfilled?',
    'ask:Finish': 'Would you like to declare contract fulfilled?',
    'ask:Cancel': 'Would you like to request to cancel contract?',
    'ask:Agree-Cancel': 'Would you like to agree to cancel contract?',
    'ask:Cancel-Cancel': 'Would you like to withdraw the cancellation request?',
    // tr
    'tr:Apply': '{profile} has applied.',
    'tr:Ask-hire': '{profile} has requested to hire him/her.',
    'tr-ask:Ask-hire': 'If you want to hire {profile}, please press the "Hire" button at the top of the screen.',
    'tr:Hire': '{profile} has hired {partner}.',
    'tr:Ask-finish': '{profile} has requested to declare contract fulfilled.',
    'tr-ask:Ask-finish': 'If you believe the task has been successfully completed, please press the "Declare Contract Fulfilled" button at the top of the screen.',
    'tr:Finish': '{profile} has declared contract fulfilled.',
    'tr:Cancel': '{profile} has requested to cancel contract.',
    'tr-ask:Cancel': 'If you agree to cancel, please press "Agree to Cancel Contract," otherwise, send your disagreement through messages.',
    'tr:Agree-Cancel': '{profile} has agreed to cancel contract.',
    'tr:Cancel-Cancel': '{profile} has withdrawn the cancellation request.',
    'tr:Set-Price': '{profile} has set the price as {price}.',
    'tr:Review': '{profile} has posted a review on {partner}.',
  },
}

export const processDictionaryKeys: string[] = [
  ':common',
  'cm:hire',
  ':st',
  'st:Start',
  'st:Open',
  'st:Hired',
  'st:WorkFinished',
  'st:Closed',
  'st:Canceled',
  // act
  ':act',
  'act:Apply',
  'act:Ask-hire',
  'act:Hire',
  'act:Ask-finish',
  'act:Finish',
  'act:Cancel',
  'act:Agree-Cancel',
  'act:Cancel-Cancel',
  'act:Ask-Refund',
  'act:Propose-Refund',
  'act:Edit-Refund',
  'act:Set-Price',
  'act:Review',
  'act:Close-Offer',
  'act:Change-JobReward',
  // ask
  ':ask',
  'ask:Apply',
  'ask:Ask-hire',
  'ask:Hire',
  'ask:Ask-finish',
  'ask:Finish',
  'ask:Cancel',
  'ask:Agree-Cancel',
  'ask:Cancel-Cancel',
  // tr
  ':tr',
  'tr:Apply',
  'tr:Ask-hire',
  'tr-ask:Ask-hire',
  'tr:Hire',
  'tr:Ask-finish',
  'tr-ask:Ask-finish',
  'tr:Finish',
  'tr:Cancel',
  'tr-ask:Cancel',
  'tr:Agree-Cancel',
  'tr:Cancel-Cancel',
  'tr:Set-Price',
  'tr:Review',
]

export function getTranslatedStateName (process: ChatRoomProcess | undefined | null, state: ProcessState) {
  const key = `st:${state.id}`
  const name = lookUpDictionary(process, key) ?? 'Unknown'
  return name
}

type ActionNameMode = 'act' | 'ask' | 'tr' | 'tr-ask'

export function getTranslatedActionName (process: ChatRoomProcess | undefined | null, action: ProcessAction, mode: ActionNameMode = 'act', tr?: MessageTransaction) {
  let actionId = action.id

  // 개발 중간에 잘못된 값이 들어간 것 처리
  if (typeof action.id === 'object') {
    actionId = (action.id as ProcessAction).id
  }

  // 이전 버전 지원 (ask에 대해 action이 )
  if (tr?.type === 'ask-action') {
    if (!actionId.startsWith('Ask')) {
      switch (actionId) {
        case 'Hire':
          actionId = 'Ask-hire'
          break
        case 'Finish':
          actionId = 'Ask-finish'
          break
      }
    }
  }

  const key = `${mode}:${actionId}`
  const name = lookUpDictionary(process, key) ?? actionId
  return name
}

function lookUpDictionary (process: ChatRoomProcess | undefined | null, key: string): string | undefined {
  const lang = i18n.locale.startsWith('ko') ? 'ko' : 'en'
  const pDic = process?.dictionary?.[lang]
  const def = defaultProcessDictionary?.[lang]
  if (!def?.[key]) {
    console.error('lookUpDictionary: NO default value', key)
    return undefined
  }

  if (pDic) {
    if (pDic[key]) {
      return pDic[key]
    }
    let value = def[key]
    if (pDic['cm:hire']) {
      value = value.replace(def['cm:hire'] ?? '', pDic['cm:hire'])
      value = value.replace(capitalize(def['cm:hire'] ?? ''), capitalize(pDic['cm:hire']))
    }
    return value
  } else {
    return def[key]
  }

  return undefined
}

function capitalize (str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
